var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "content-main",
          class: { "plus-content-main": _vm.plusContentManFlag }
        },
        [
          _c("breadcrumb", {
            attrs: { menuObject: _vm.menuObject },
            on: { middleWare: _vm.middleWare }
          }),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex" },
            [
              _c("left-menu", {
                staticClass: "left-menu",
                attrs: { menuObject: _vm.menuObject },
                on: { middleWare: _vm.middleWare }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right-content" },
                [
                  _c("RightCom", {
                    key:
                      _vm.queryObject.collectionId + _vm.queryObject.menuName,
                    attrs: {
                      type: "product",
                      queryObject: _vm.queryObject,
                      isShowBrandTag: true
                    },
                    on: {
                      setShowAnProduct: _vm.setShowAn,
                      showLogin: _vm.showLoginHandle,
                      pageChanged: _vm.updatePage
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("footer-com", {
        key: _vm.showan,
        attrs: { value: _vm.showan },
        on: {
          hideShow: function($event) {
            _vm.showan = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-714056de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-714056de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/product/index.vue
// module id = null
// module chunks = 